import tw from "tailwind-styled-components";
import { FaRupeeSign, FaRegCalendar } from "react-icons/fa";
import { FaRegClock } from "react-icons/fa6";
import { IoMdPhonePortrait } from "react-icons/io";

export const InputGroup = tw.div`w-full flex flex-col md:space-y-1.5 space-y-1 mt-2 md:mt-0`;

export const CombineInputGroup = tw.div`w-full flex md:flex-row flex-col space-x-4 items-end`;
export const combineLabelInput = tw.div`grid md:grid-cols-2 grid-cols-1`
export const FieldWrapper = tw.div`
${(p) => (p.$select ? "h-10" : "pl-2   field-wrapper border border-gray-300")}
 relative  rounded-md  w-full  flex items-center`;
export const FieldWrappers = tw.div`pl-2 relative rounded-md w-full flex items-center border border-gray-200 h-12`;
// export const Label = tw.label`text-sm text-gray-500 font-normal`;

export const Label = tw.label`text-sm text-gray-500 font-normal`;
export const ModalHeading = tw.h2`font-semibold mt-0 text-gray-800`;
export const ModalSubHeading = tw.h4`text-sm text-gray-500 font-normal mt-4`;
export const ModalLabel = tw.h4`text-base text-gray-700 font-medium`;

export const WrapperHeading = tw.h2`mt-4`;
export const FormContainer = tw.div` grid max-w-2xl gap-5 md:gap-7 mt-4`;

export const FormContainerVertical = tw.div` grid  gap-5 md:gap-7 mt-4`;

// export const SubmitBtn = tw.button`
// text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;

export const SubmitBtn = tw.button`
text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base hover:brightness-110 text-white rounded-md shadow-md bg-gradient-to-r from-primary-color to-[#00A0FF]`;


export const PreviewBtn = tw.button`
text-sm w-32 md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base bg-cyan-100 hover:bg-cyan-200 text-cyan-700 rounded-md shadow-md`;

export const OtherBtn = tw.button`
  text-sm w-32 md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-base bg-green-100 hover:bg-green-200 text-gray-600 rounded-md shadow-md`;

export const PrevBtn = tw.button`
  text-sm  w-32  md:w-32 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-gray-200 hover:bg-gray-100 text-gray-600 rounded-md shadow-md`;

export const SaveBtn = tw.button`
  text-sm  w-32  md:w-32 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-cyan-100 hover:bg-cyan-200 text-cyan-700 rounded-md shadow-md`;

export const SmallBtn = tw.button`
  whitespace-nowrap text-xs px-4 py-2 sm:px-6 sm:py-2.5 rounded-md bg-white-400  cursor-pointer hover:bg-gray-200 shadow border transition duration-200 text-gray-600 sm:text-sm`;

export const SideCancelBtn = tw.button`
  text-sm w-32 md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed md:text-base text-gray-600 `;

export const CancelBtn = tw.button`
  text-sm  w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed   md:text-base bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-md shadow-md`;
export const CardWrapper = tw.div`flex md:gap-4 gap-2 my-1.5`;
export const SelectionCard = tw.button`flex flex-col items-center justify-center py-2 px-2 lg:px-4 border rounded-full shadow-sm cursor-pointer`;
export const OptionText = tw.span`text-sm text-gray-600`;
export const Summary = tw.div``;
export const SummaryTitle = tw.h3` font-semibold mb-1`;
export const SummaryRow = tw.div`flex justify-between items-center my-1`;
export const SummaryLabel = tw.span`text-sm text-gray-600`;
export const SummaryValue = tw.span`text-sm font-semibold`;
export const Wrapper = tw.div`grid gap-4 mt-4 overflow-y-auto`;
export const ActionSection = tw.div`px-4 py-2 bg-white flex justify-between border-t border-gray-200 absolute bottom-0 left-0 w-full`;
export const ScrollableContent = tw.div`flex-grow overflow-y-auto max-h-[calc(100dvh-200px)] custom-scrollbar pb-10 scrollbar-hide`;
export const RupeeIcon = tw(FaRupeeSign)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const CalendarIcon = tw(FaRegCalendar)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const ClockIcon = tw(FaRegClock)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-3
`;
export const MobileIcon = tw(IoMdPhonePortrait)`
  absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-3 h-4
`;
export const Note = tw.p`text-xs text-gray-400 flex`;

export const ReplicateSection = tw.div`
  bg-white border border-gray-200 rounded-2xl p-5 shadow-sm
`;

export const ReplicateHeader = tw.div`mb-4`;

export const ReplicateTitle = tw.h4`
  text-base font-semibold text-gray-800
`;

export const ReplicateSubtitle = tw.p`
  text-xs text-gray-500 mt-1
`;

export const ReplicateContent = tw.div`flex flex-col gap-3`;

export const ReplicateSelectionCard = tw.div`
  flex items-center justify-between 
  border border-gray-200 rounded-xl px-4 py-3 
  hover:border-primary-color hover:bg-gray-50 
  transition-all duration-200 cursor-pointer
`;

export const PrimaryAction = tw.button`
  w-full h-12 rounded-xl font-medium text-sm
  bg-primary-color text-white
  hover:opacity-90
  disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed
  transition-all duration-200
`;

export const RecommendedBadge = tw.span`
  text-[10px] font-medium px-2 py-0.5 rounded-full
  bg-blue-100 text-blue-700
`;

export const ImpactText = tw.p`
  text-[11px] text-green-600 mt-1 font-medium
`;

export const BadgeGroup = tw.div`
  flex items-center gap-1.5
`;

export const ModalHeader = tw.div`
  flex items-center justify-between 
  bg-gradient-to-r from-primary-color to-[#00A0FF] 
  py-4 px-5 
  shadow-md
`;

export const ModalTitle = tw.h1`text-lg font-medium text-white`;

export const DeleteBtn = tw.button`
 text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base bg-primary-color hover:bg-hover-color text-white rounded-md shadow-md`;


//  *********** Model CSS **************

 export const SubContainer = tw.div`fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50`;
 export const ModalContainer = tw.div`
bg-white w-full max-w-3xl rounded-2xl
 overflow-hidden
flex flex-col
`;
export const ModalContent = tw.div`px-6 py-5 flex-1 overflow-y-auto`;

export const ModalSection = tw.div`bg-gray-100/60 rounded-xl p-5 mb-3`;
//const SectionTitle = tw.h2`text-base font-medium text-gray-600 flex justify-between items-center`;
export const ModalSectionTitle = tw.h2`
text-sm font-semibold uppercase tracking-wide text-gray-500
`;
//const Row = tw.div`grid grid-cols-2 py-1 md:p-1`;
export const ModalRow = tw.div`
grid grid-cols-2 gap-4 py-3
`;
export const ModalRowLabel = tw.label`text-sm text-gray-500 font-normal`;
//export const ModalRowValue = tw.span`text-gray-800 text-md`;
export const ModalRowValue = tw.span`
    text-gray-800
    text-md
    min-w-0
    break-words
    [overflow-wrap:anywhere]
`;
export const EditButton = tw.button`
inline-flex items-center
px-3 py-1.5
rounded-lg
bg-blue-50
text-primary-color
hover:bg-blue-100
transition-colors duration-150
text-sm font-medium
`;